<section class="content">

    <section class="opportunities-intro-section">
        <p class="typography-title-l">{{ 'my_profile.my_opportunities.title' | translate }}</p>
        <p class="typography-title-s description">{{ 'my_profile.my_opportunities.subtitle' | translate }}</p>
    </section> 

    <section class="opportunities-form">
        <section class="opportunities-intro">
            <p class="typography-title-m">{{ 'my_profile.my_opportunities.title_configuration' | translate }}</p>
        </section>    

        <section class="opportunities-atts">
            <form class="opportunities-atts-form-config">
                <div class="form-group">
                    <div class="col-span-12 configuration-options">
                        <label for="configuration">{{ 'my_profile.my_opportunities.subtitle_configuration' | translate }}</label>
                        <label class="configuration-option">
                            <app-checkbox
                                class="mr-2"
                                [checked]="selectedConfigs.has('cocina')"
                                [disabled]="disabledConfigs.has('cocina')"
                                (checkboxChange)="onConfigChange('cocina', $event)"
                            />
                            <span class="typography-body-m-regular">{{ 'my_profile.my_opportunities.configurations.configuration1' | translate }}</span>
                        </label>
                        <label class="configuration-option">
                            <app-checkbox
                                class="mr-2"
                                [checked]="selectedConfigs.has('encimera')"
                                [disabled]="disabledConfigs.has('encimera')"
                                (checkboxChange)="onConfigChange('encimera', $event)"
                            />
                            <span class="typography-body-m-regular">{{ 'my_profile.my_opportunities.configurations.configuration2' | translate }}</span>
                        </label>
                        <label class="configuration-option">
                            <app-checkbox
                                class="mr-2"
                                [checked]="selectedConfigs.has('baño')"
                                [disabled]="disabledConfigs.has('baño')"
                                (checkboxChange)="onConfigChange('baño', $event)"
                            />
                            <span class="typography-body-m-regular">{{ 'my_profile.my_opportunities.configurations.configuration3' | translate }}</span>
                        </label>
                    </div>
                </div>
                <app-button [primary]="true" skin="we" size="m" type="secondary" [disabled]="!isConfigModified" (click)="onSaveConfigurations()">
                    {{ 'my_profile.my_opportunities.save_button' | translate }}
                </app-button>
            </form>
        </section>
    </section>

    <section class="opportunities-form">
        <section class="opportunities-intro">
            <p class="typography-title-m">{{ 'my_profile.my_opportunities.title_unsuscribe' | translate }}</p>
        </section>    

        <section class="opportunities-atts">
            <form class="opportunities-atts-form">
                <span class="typography-body-s-light">{{ 'my_profile.my_opportunities.help_message1_unsuscribe' | translate }}</span>
                <div class="form-group">
                    <label for="reason">{{ 'my_profile.my_opportunities.select_reason' | translate }}</label>
                    <div class="custom-select">
                        <app-select
                            [placeholder]="'my_profile.my_opportunities.select_reason_placeholder' | translate"
                            [options]="reasonOptions"
                            [selectedValue]="selectedReasonOption"
                            (selectedValueChanged)="onReasonChange($event)">
                        </app-select>
                    </div>
                </div>

                <div *ngIf="selectedReason === 'temporarily-close'" class="form-group">
                    <label for="startDate">{{ 'my_profile.my_opportunities.start_date' | translate }}</label>
                    <app-input
                        [type]="'date'"
                        [value]="startDate"
                        [min]="minDate"
                        (valueChanged)="onStartDateChange($event)"
                    ></app-input>
                </div>

                <div *ngIf="selectedReason === 'temporarily-close'" class="form-group">
                    <label for="endDate">{{ 'my_profile.my_opportunities.end_date' | translate }}</label>
                    <app-input
                        [type]="'date'"
                        [value]="endDate"
                        [min]="minEndDate"
                        (valueChanged)="endDate = $event"
                    ></app-input>
                </div>

                <div class="form-group">
                    <label for="subject">{{ 'my_profile.my_opportunities.comments' | translate }}</label>
                    <textarea id="subject"
                        name="subject"
                        class="subject-text-area"
                        [placeholder]="'my_profile.my_opportunities.comments_placeholder' | translate"
                        [(ngModel)]="subject"
                        aria-label="subject">
                    </textarea>
                </div>
                <span class="typography-body-s-light">{{ 'my_profile.my_opportunities.help_message2_unsuscribe' | translate }}</span>
                <app-button [primary]="true" skin="we" size="m" type="secondary" [disabled]="isUnsubscribeDisabled" (click)="onUnsubscribe()">
                        {{ 'my_profile.my_opportunities.unsuscribe_button' | translate }}
                </app-button>
            </form>
        </section>
    </section>
</section>